import { render, staticRenderFns } from "./course-chunk.vue?vue&type=template&id=2c82113f&scoped=true"
import script from "./course-chunk.vue?vue&type=script&lang=js"
export * from "./course-chunk.vue?vue&type=script&lang=js"
import style0 from "./course-chunk.vue?vue&type=style&index=0&id=2c82113f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c82113f",
  null
  
)

export default component.exports